import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Menu,
  MenuItem,
  Typography,
  Avatar,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getUserInfo } from "../apis/apis"

export default function Navbar() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [userInfo, setUserInfo] = useState(null);

  const pagesList = [
    { 
      pageName: "Home",
      url: "/"
    },
    { 
      pageName: "Settings",
      url: "/settings"
    }
  ]

  useEffect(() => {
    document.documentElement.style.setProperty('--navbar-height', '64px');
    
    const fetchUserInfo = async () => {
      try {
        const userInfoData = await getUserInfo();
        setUserInfo(userInfoData);
      } catch (error) {
        console.error('Error fetching user info:', error); 
        if (error.message.includes("401")) {
          localStorage.removeItem("token");
          navigate("/signin");
        }
      }
    };

    if (localStorage.getItem("token")) {
      fetchUserInfo();
    }
  }, []);

  
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/signin");
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        width: "100vw",
        left: 0,
        top: 0,
      }}
    >
      <Toolbar>
        <Box sx={{ flexGrow: 1, display: 'flex' }}>
          { pagesList.map((page) => (
            <MenuItem key={page.pageName} onClick={() => navigate(page.url)} sx={{borderRadius: "15px"}}>
              <Typography sx={{ textAlign: 'center' }}>{page.pageName}</Typography>
            </MenuItem>
          ))}
        </Box>
        <Box sx={{ flexGrow: 0 }}>
          {userInfo && <span>{userInfo?.name}</span>}
          <IconButton size="large" onClick={handleMenu} color="inherit">
            <Avatar src={userInfo?.profilePhotoUrl} alt={userInfo?.name} />
          </IconButton>

          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
      
    </AppBar>   
  );
}
